module.exports = __webpack_public_path__ + "img/mtt_7.1.0f23b324.png";